import React, { PropsWithChildren } from "react";
import { PREMIUM_FEATURES } from "@common/flatRateBilling";
import { MainInterface } from "@components/mainInterface/MainInterface";
import { FeatureAccess } from "@components/settings/FeatureAccess/FeatureAccess";
import { InvoicingPaywalled } from "./InvoicingPaywalled";
import { useCanUseInvoicing } from "@hooks/useCanUseInvoicing";

export const InvoicingAccess: React.FC<PropsWithChildren> = ({ children }) =>
    useCanUseInvoicing() ? <>{children}</> : null;

export const InvoicingRouteAccess: React.FC<PropsWithChildren> = ({
    children,
}) => (
    <FeatureAccess
        feature={PREMIUM_FEATURES.INVOICES}
        renderAllowed={() => <>{children}</>}
        renderBlocked={() => (
            <MainInterface breadcrumbs={[{ label: "Invoicing" }]}>
                <InvoicingPaywalled />
            </MainInterface>
        )}
    />
);
